import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { restRequestMultiple } from 'common-src/features/rest/actions';
import {
  catchLabOrderErrors,
  extractLabOrder,
  getPatientLabOrders,
} from 'common-src/models/PatientLabOrder';

import { LabOrders as LabOrdersForm } from 'src/components/forms';
import useAlert from 'src/hooks/useAlert';
import useCustomSelector from 'src/hooks/useCustomSelector';
import useFormButtons from 'src/hooks/useFormButtons';

import { getLabOrderRequests } from './helpers';

const LabOrders = ({ patientId, isEditEnabled }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState([]);

  const labOrders = useCustomSelector((state) => getPatientLabOrders(state, patientId));

  const { showAlert, AlertType } = useAlert();

  const onSubmitHandler = (setIsLoading, setIsEditMode, handleErrors) => {
    const { errors, hasErrors } = catchLabOrderErrors(formData);
    if (hasErrors) {
      handleErrors(errors);
      return;
    }

    setIsLoading(true);
    dispatch(
      restRequestMultiple({
        restRequests: getLabOrderRequests(formData, labOrders),
        successBlock: () => {
          setIsEditMode(false);
          setIsLoading(false);
          showAlert(AlertType.Success, '', 'You have successfully updated lab orders.');
        },
        errorBlock: (err) => {
          setIsLoading(false);
          showAlert(AlertType.Error, '', err);
        },
      }),
    );
  };

  const onEditHandler = () => {
    setTimeout(() => {
      const element = document.getElementById('lab-orders-buttons');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }, 0);
  };

  const {
    isEditMode,
    setIsEditMode,
    setIsLoading,
    errors,
    setErrors,
    handleErrors,
    renderContent,
    setInitialData,
  } = useFormButtons(
    'section',
    setFormData,
    () => onSubmitHandler(setIsLoading, setIsEditMode, handleErrors),
    formData,
    true,
    'labOrders',
  );

  useEffect(() => {
    const data = !_.isEmpty(labOrders)
      ? labOrders.map((labOrder) => extractLabOrder(labOrder))
      : [];

    setInitialData(data);
    setFormData(data);
  }, [labOrders]);

  return (
    <>
      <LabOrdersForm
        patientId={patientId}
        isEditMode={isEditMode}
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        setErrors={setErrors}
        patientLabOrders={labOrders}
        addButtonHandler={onEditHandler}
      />
      <div id="lab-orders-buttons" className="scroll-m-b-20">
        {renderContent(false, !isEditEnabled, onEditHandler)}
      </div>
    </>
  );
};

LabOrders.propTypes = {
  patientId: PropTypes.number,
  isEditEnabled: PropTypes.bool,
};

export default LabOrders;
